export default __webpack_public_path__ + "static/media/h-icon.3bd79252.svg";